import { StatusBar } from 'expo-status-bar';
import React,{useEffect,useState}  from 'react';
import { StyleSheet, Text, View, Image, TextInput,TouchableOpacity, Alert,BackHandler} from 'react-native';
import ButtonGradient from '../modules/component/ButtonGradient';
import { useNavigation } from '@react-navigation/native';
import Fondo from '../modules/component/Fondo';
import { LinearGradient } from 'expo-linear-gradient';



  const Factura = () => {


    const [errorMsg, setErrorMsg] = useState(null);
    const navigation = useNavigation({

      Factura :{

        screen: 'Factura',
        navigationOptions:{
        headerShown: false
        },

      }

    });


   

    const [state,setState] = useState({

      folioRecibo: "",
      estatus: ""

    });

    const handleChangetest = (name, value) => {


      setState({...state, [name]: value})

    }


    useEffect(() => {
      
      setState({...state, ["folioRecibo"]: global.gFolioRecibo});
      setState({...state, ["estatus"]: global.gEstatusFactura});
    
    }, []);

 
    const limpiarFormulario = () => {

      setState('')

    }
   
    const showAlert = () => 
   
    Alert.alert(gMsg, 'Oprima Aceptar para continuar', [
      { text: "Aceptar" }
      ],
      { cancelable: true });


    async function Guardar(){

     /* var datos = '{"empresa" : "' + state.empresa + '","usuario" : "' + state.usuario + '","contrasena" : "' + state.contrasena + '"}' 

      var requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: datos
      };
      
        const response = await apiFetch(gApiPath + "/api/login",requestOptions);
        const json = await response.json();
        
        if (json.estatus == "bien"){

          datos = json.datos
          gEmpresa = state.empresa;
          gUsuario = state.usuario;
          gIdUsuario = datos["id"];
         
          limpiarFormulario();
     
          navigation.navigate('DashboardRuta');
    
        }else{

          gMsg = json.mensaje; 
          limpiarFormulario();
          showAlert();
     
        }*/
    
    }
 

    
    return(
  
    <View style={styles.container}>
        <Fondo/>
        <LinearGradient colors={['#0052D4', '#4364F7', '#6fb1fc']} start={{x:1, y:0}} end={{x:0, y:1}} style={styles.button}>
            <Text style={styles.titulo2}>Folio factura:</Text>
            <Text style={styles.titulo3}>{global.gFolioFactura}</Text>
            
            <Text style={styles.titulo2}>Fecha emisión:</Text>
            <Text style={styles.titulo3}>{global.gFechaEmision}</Text>

            <Text style={styles.titulo2}>Monto:</Text>
            <Text style={styles.titulo3}>{"$ " + global.gMonto}</Text>

            <Text style={styles.titulo2}>Folio recibo</Text>
            <TextInput style={styles.textInput}
              value={global.gFolioRecibo}  
              onChangeText = {(value) => handleChangetest("folioRecibo",value)}
            />
            <StatusBar style="auto" />
        </LinearGradient>

        <TouchableOpacity  style={styles.container2} onPress={()=>Guardar()}>
          <ButtonGradient texto="Guardar" />
        </TouchableOpacity>
    
      </View>
    
    );
  }

export default Factura



const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f1f1f1',
    alignItems: 'center'
  

  },

  titulo1:{
    fontSize: 40,
    color: "white",
    fontWeight: 'bold',
    paddingTop: "30%"  
  },

  titulo2:{
    fontSize: 40,
    color: "white",
    fontWeight: 'bold',
    paddingTop: 20  },

    titulo3:{
      fontSize: 40,
      color: "black",
      fontWeight: 'bold',
      paddingTop: 2  },

  subTitle:{
    fontSize: 45,
    color: '#151515',
    marginTop: 80,
    margin: 50,
    fontWeight: 'bold',

  },
  textLabels:{

    padding: 5,
    width: '80%',
    marginTop: 5,
    fontWeight: 'bold',
    color: '#ffff',
    fontSize: 20
  },
  textLabels2:{

    padding: 5,
    width: '80%',
    marginTop: 50,
    fontWeight: 'bold',
    color: '#ffff',
    fontSize: 20,
    paddingTop: "40%"
  },
  textInput:{

    padding: 5,
    width: '80%',
    height: 50,
    marginTop: 5,
    borderRadius: 10,
    fontWeight: 'bold',
    backgroundColor: '#ffff',
    fontSize: 35,
    textAlign: "center",
  
  },
  background: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    height: 1000,
  },
  
    subTitle2:{
    fontSize: 15,
    color: 'gray',
    marginTop: 5,
    fontWeight: 'bold'

  },container2:{
      
    alignItems: 'center',
    justifyContent : 'center',
    marginTop:40,
    width: '80%',
    height: 50


},
button:{

  width: '90%',
  height: '80%',
  marginTop:'10%',
  borderRadius: 5,
  borderWidth: 10,
  borderColor: 'white',
  fontWeight: 'bold',
  alignItems: 'center',
  justifyContent : 'center'
  
  }

  
});


